<template>
    <div class="tc-lower-helpers">
        <div class="tc-div-contents">
            <ContextHelperDND v-if="defineUIContext === 'items'"/>
            <ContextHelperSelect v-if="defineUIContext === 'presets'"/>
            <ContextHelperCtrl v-if="defineUIContext === 'ctrl'"/>
            <div class="tc-lower-helpers-separator"></div>
        </div>
        <LowerHelpersButton/>
    </div>
</template>

<script>
import { useStoreUI } from '@/Store/storeUI';
import LowerHelpersButton from '@/UI/Workspace/LowerHelpersButton.vue';
import ContextHelperDND from '@/UI/Guide/ContextHelperDND.vue';
import ContextHelperSelect from '@/UI/Guide/ContextHelperSelect.vue';
import { defineUIContext } from '@/libs/defineUIContext';
import ContextHelperCtrl from '@/UI/Guide/ContextHelperCtrl.vue';

export default {
    name: 'LowerHelpers',
    components: {
        ContextHelperSelect,
        ContextHelperDND,
        LowerHelpersButton,
        ContextHelperCtrl,
    },
    setup() {
        const storeUI = useStoreUI();
        return {
            storeUI,
        };
    },
    computed: {
        defineUIContext,
    },
};
</script>

<style scoped lang="scss">
.tc-lower-helpers {
    width: 100%;
    height: max-content;
    gap: 8px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
}

.tc-lower-helpers-separator {
    width: 20px;
    height: 1px;
    background-color: #D9D9D9;
    display: flex;
    justify-content: center;
    align-items: center;
}

.tc-hide {
    opacity: 0;
}
</style>
